import api from '../token';

export const DeleteCambio = async (dados) => {
  try {
    const response = await api.post('/deleteCambio', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};






